import { API_ENDPOINTS } from "../../../../Api/apiEndPoints"
import axiosInstance from "../../../../Api/axiosInstance"

export const getExpenseList = async () => {
    let response = await axiosInstance.get(API_ENDPOINTS.CONFIGURATION.GET_EXPENSE_LIST);
    return response.data;
}

export const getSingleExpense = async (id: number) => {
    const response = await axiosInstance.get(`${API_ENDPOINTS.CONFIGURATION.GET_SINGLE_EXPENSE}/${id}`);
    return response.data;
}


///////// PURPOSE

interface AddRequestPurpose {
    title: string,
    budget: number,
    notes: string,
    expenses: number[],
    status: number,
    isDefault: Boolean
}

interface updateReqPurpose {
    id: number;
    title: string;
    budget: number;
    notes: string;
    expenses: number[];
    status: number;
    isDefault: boolean;
}

// interface policesKeys {
//     data: string[] 
// }

export const getPurposeList = async () => {
    let response = await axiosInstance.get(API_ENDPOINTS.CONFIGURATION.GET_PURPOSE_LIST);
    return response.data;
}

export const getSinglePurpose = async (id: number) => {
    let response = await axiosInstance.get(`${API_ENDPOINTS.CONFIGURATION.GET_SINGLE_PURPOSE}/${id}`);
    return response.data;
}

export const UpdatePurpose = async(ReqBody:updateReqPurpose)=>{
  let response = await axiosInstance.put(`${API_ENDPOINTS.CONFIGURATION.PUT_UPDATE_PURPOSE}`,ReqBody);
  return response.data;
}
export const AddPurpose = async (Reqbody: AddRequestPurpose) => {
    let response = await axiosInstance.post(`${API_ENDPOINTS.CONFIGURATION.POST_ADD_PURPOSE}`, Reqbody);
    return response.data;
}

export const getPolicyKeys = async () => {
    let response = await axiosInstance.get(`${API_ENDPOINTS.CONFIGURATION.getPolicyKeys}`);

    return response.data;
}

export const AddExpenseHead = async (body: any) => {
    let response = await axiosInstance.post(`${API_ENDPOINTS.CONFIGURATION.AddExpenseHead}`, body);
    return response.data;
}
export const updateExpHead = async (body: any) => {
    let response = await axiosInstance.put(`${API_ENDPOINTS.CONFIGURATION.updateExpenseHead}`, body);
    return response.data;
}